import React, { Component } from 'react';
import './AirSlider.css';
import { Slider } from 'antd';
import { inject, observer } from 'mobx-react';

import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';

@inject('commonStore')
@observer
export default class AirSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onChange = v => {
    if (isFunction(this.props.onChange)) {
      this.props.onChange(v);
    }
  };

  render() {
    let [selectedMin, selectedMax] = !!this.props.range ? this.props.value : [false, false];
    let selected = !this.props.range ? this.props.value : false;
    let divisor = 1;
    if (this.props.hasOwnProperty('stepAsDivisor') && this.props.stepAsDivisor) {
      divisor = this.props.step;
    }
    selected = isNumber(selected) ? Math.round((selected * 100) / divisor) / 100 : false;
    selectedMin = isNumber(selectedMin) ? Math.round(selectedMin / divisor) : false;
    selectedMax = isNumber(selectedMax) ? Math.round(selectedMax / divisor) : false;
    return (
      <div className={`AirSlider ${this.props.className || ''} ${this.props.hasOwnProperty('horizontal') ? 'horizontal' : ''}`}>
        {(!!this.props.label || this.props.visibleSelectedValues !== false) && (
          <div className="header">
            {!!this.props.label && <div className="label">{this.props.label}</div>}
            {this.props.visibleSelectedValues !== false &&
              ((!!selectedMin || selectedMin === 0) && (!!selectedMax || selectedMax === 0) && (
                <div className="selectedValues">
                  {this.props.showLocale && (
                    <div>
                      {selectedMin.toLocaleString(this.props.commonStore.momentLocale)}-{selectedMax.toLocaleString(this.props.commonStore.momentLocale)}&nbsp;{this.props.uom}
                    </div>
                  )}
                  {!this.props.showLocale && (
                    <div>
                      {selectedMin}-{selectedMax}&nbsp;{this.props.uom}
                    </div>
                  )}
                </div>
              ))}
            {this.props.visibleSelectedValues !== false &&
              ((!!selected || selected === 0) && (
                <div className="selectedValues">
                  {this.props.showLocale && (
                    <div>
                      {selected.toLocaleString(this.props.commonStore.momentLocale)}&nbsp;{this.props.uom}
                    </div>
                  )}
                  {!this.props.showLocale && (
                    <div>
                      {selected}&nbsp;{this.props.uom}
                    </div>
                  )}
                </div>
              ))}
          </div>
        )}
        <Slider
          disabled={this.props.disabled}
          onChange={this.onChange}
          min={this.props.min}
          max={this.props.max}
          range={this.props.range}
          tipFormatter={this.props.tipFormatter}
          tooltipVisible={false}
          value={this.props.value}
          step={this.props.step}
        />

        {this.props.visibleMinMax !== false && (
          <div className="minmax">
             <div className="min">
            {this.props.showLocale && (
              <span>
                {this.props.min.toLocaleString(this.props.commonStore.momentLocale)}&nbsp;{this.props.uom}
              </span>
              )}
              {!this.props.showLocale && (
                <span>
                  {this.props.min} {this.props.uom}
                </span>
              )}
            </div>
            <div className="max">
              {this.props.showLocale && (
                <span>
                  {this.props.max.toLocaleString(this.props.commonStore.momentLocale)}&nbsp;{this.props.uom}
                </span>
              )}
              {!this.props.showLocale && (
                <span>
                  {this.props.max} {this.props.uom}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirSlider/AirSlider.js